import { useParams, Link } from "react-router-dom";
import { ArrowLeft, ArrowRight } from "lucide-react";
import Reveal, { MaskedLine } from "../components/Reveal";
import POSTS from "../data/posts";

const BlogPost = () => {
  const { slug } = useParams();
  const post = POSTS.find((p) => p.slug === slug);

  if (!post) {
    return (
      <div className="pt-40 pb-36 max-w-[1400px] mx-auto px-6 lg:px-10" data-testid="blog-post-not-found">
        <h1 className="font-display font-medium text-4xl tracking-tight">Article not found</h1>
        <Link to="/blog" data-testid="blog-back-link" className="inline-flex items-center gap-2 mt-6 text-sm font-medium text-emerald">
          <ArrowLeft className="w-4 h-4" strokeWidth={1.5} /> Back to Journal
        </Link>
      </div>
    );
  }

  return (
    <div data-testid="blog-post-page" className="pt-32 lg:pt-40 pb-24 lg:pb-36">
      <div className="max-w-[820px] mx-auto px-6">
        <Link to="/blog" data-testid="blog-back-link" className="group inline-flex items-center gap-2 text-sm font-medium text-obsidian/50 hover:text-emerald transition-colors duration-200 mb-10">
          <ArrowLeft className="w-4 h-4 transition-transform duration-300 group-hover:-translate-x-1" strokeWidth={1.5} />
          The Polymer Journal
        </Link>
        <p className="text-[11px] uppercase tracking-[0.2em] font-semibold text-emerald mb-4">
          {post.category} · {post.readTime}
        </p>
        <h1 className="font-display font-semibold tracking-tighter leading-[1.02] text-4xl sm:text-5xl lg:text-6xl">
          <MaskedLine>{post.title}</MaskedLine>
        </h1>
        <div className="mt-12 space-y-7">
          {post.body.map((para, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <p className="text-obsidian/70 leading-[1.85] text-base lg:text-lg">{para}</p>
            </Reveal>
          ))}
        </div>
        <Reveal className="mt-16 border border-line bg-white p-8 lg:p-10">
          <p className="font-display font-medium text-2xl tracking-tight">Have a packaging question?</p>
          <p className="text-obsidian/60 text-sm mt-2 leading-relaxed">
            Twenty-three years of moulding HDPE is a short phone call away. Tell us what you need to pack.
          </p>
          <Link
            to="/contact"
            data-testid="blog-post-enquiry-cta"
            className="group inline-flex items-center gap-2 mt-6 bg-obsidian text-bone text-sm font-medium px-7 py-3.5 rounded-full hover:bg-emerald transition-colors duration-300"
          >
            Start an Enquiry
            <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.5} />
          </Link>
        </Reveal>
      </div>
    </div>
  );
};

export default BlogPost;
